import React, { useCallback, useMemo, useState } from 'react'
import PropTypes from 'prop-types'

import colors from 'styles/colors'
import {
  ServiceItem,
  ServiceItemIcon,
  ServiceItemTitle,
  ServiceSelector,
} from './VirtualServicesTabs.style'

const hexRegex = /^#([0-9a-f]{6}|[0-9a-f]{3})$/i

const VirtualServicesTabs = ({
  services = [],
  onServiceTabClick = () => {},
}) => {
  const [selectedServiceIndex, setSelectedServiceIndex] = useState(
    services.length > 0 ? 0 : -1
  )

  const isBrowser = typeof window !== 'undefined'

  const manipulatedServices = useMemo(() => {
    if (isBrowser) {
      const parser = new DOMParser()

      return services.map((service) => {
        const rawIcon = parser.parseFromString(service.icon, 'image/svg+xml')
        const iconElements = Array.from(rawIcon.getElementsByTagName('*'))

        const selectedIcon = parser.parseFromString(
          service.icon,
          'image/svg+xml'
        )
        const selectedIconElements = Array.from(
          selectedIcon.getElementsByTagName('*')
        )

        iconElements.forEach((element) => {
          if (hexRegex.test(element.getAttribute('fill'))) {
            element.setAttribute('fill', colors.sagemedium)
          }

          if (hexRegex.test(element.getAttribute('stroke'))) {
            element.setAttribute('stroke', colors.sagemedium)
          }

          // VALUE RETAIL ICONS - REMOVE FILTER ATTRIBUTE
          // FILTER ATTRIBUTE OVERRIDES CUSTOM COLOR SET
          if (element.getAttribute('filter')) {
            element.setAttribute('filter', null)
          }
        })

        selectedIconElements.forEach((element) => {
          if (hexRegex.test(element.getAttribute('fill'))) {
            element.setAttribute('fill', colors.sagedark)
          }

          if (hexRegex.test(element.getAttribute('stroke'))) {
            element.setAttribute('stroke', colors.sagedark)
          }

          // VALUE RETAIL ICONS - REMOVE FILTER ATTRIBUTE
          // FILTER ATTRIBUTE OVERRIDES CUSTOM COLOR SET
          if (element.getAttribute('filter')) {
            element.setAttribute('filter', null)
          }
        })

        return {
          ...service,
          icon: rawIcon.documentElement.outerHTML,
          iconSelected: selectedIcon.documentElement.outerHTML,
        }
      })
    }

    return services.map((service) => ({
      ...service,
      iconSelected: service.icon,
    }))
  }, [services])

  const onServiceClick = useCallback(
    (index) => () => {
      setSelectedServiceIndex(index)
      if (onServiceTabClick) {
        // @ts-ignore
        onServiceTabClick(index)
      }
    },
    [onServiceTabClick]
  )

  return (
    <ServiceSelector>
      {manipulatedServices.map((service, i) => {
        return (
          <ServiceItem
            onClick={onServiceClick(i)}
            onKeyDown={onServiceClick(i)}
            role="button">
            <ServiceItemIcon
              selected={i === selectedServiceIndex}
              dangerouslySetInnerHTML={{
                __html:
                  i === selectedServiceIndex
                    ? service.iconSelected
                    : service.icon,
              }}
            />
            <ServiceItemTitle selected={i === selectedServiceIndex}>
              {service.title}
            </ServiceItemTitle>
          </ServiceItem>
        )
      })}
    </ServiceSelector>
  )
}

VirtualServicesTabs.propTypes = {
  services: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      steps: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          headline: PropTypes.string,
          description: PropTypes.string,
        })
      ),
    })
  ),
  onServiceTabClick: PropTypes.func,
}

VirtualServicesTabs.defaultProps = {
  services: [],
  onServiceTabClick: () => {},
}

export default VirtualServicesTabs
